import { Box, Button, css } from '@mui/material'
import { useMQ } from '../hooks/useMQ'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { CONFIG } from '../utils/config'
import { HumaScrollAnimation } from './HumaScrollAnimation'
import { Title } from './Title'
export function Huma2() {
  const { isXsSize, isSmSize } = useMQ()

  const getWrapperStyle = () => {
    if (isXsSize) {
      return css`
        margin-top: 96px;
      `
    }
    if (isSmSize) {
      return css`
        margin-top: 160px;
      `
    }
    return css`
      margin-top: 240px;
    `
  }

  const getDescriptionStyle = () => {
    if (isXsSize) {
      return css`
        font-size: 18px;
        line-height: 24px;
        max-width: 350px;
      `
    }
    if (isSmSize) {
      return css`
        font-size: 18px;
        line-height: 24px;
        max-width: 500px;
      `
    }

    return css`
      font-size: 24px;
      line-height: 40px;
      max-width: 770px;
    `
  }

  const styles = {
    wrapper: css`
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      z-index: 1;
      position: relative;
      ${getWrapperStyle()}
    `,
    description: css`
      color: #ececec;
      font-weight: 300;
      ${getDescriptionStyle()}
    `,
    buttonContainer: css`
      margin-top: 40px;
      display: flex;
      gap: 16px;
    `,
    button: css`
      padding: ${isXsSize ? '0px 30px' : '0px 24px'};
      height: ${isXsSize ? '42px' : '48px'};
      width: ${isSmSize ? '100%' : 'auto'};
    `,
    payfiButtonText: css`
      white-space: nowrap;
      margin-right: ${isXsSize ? '0px' : '16px'};
    `,
  }

  return (
    <HumaScrollAnimation>
      <Box css={styles.wrapper}>
        <Title title='Introducing Huma 2.0' />
        <Box css={styles.description}>
          Permissionless DeFi yield, powered by real-world payment flows. Choose
          how to earn and connect to DeFi on Solana.
        </Box>
        <Box css={styles.buttonContainer}>
          <Button
            variant='contained'
            size='large'
            css={styles.button}
            href={CONFIG.permissionlessLink}
            target='_blank'
            rel='noreferrer'
          >
            <Box css={styles.payfiButtonText}>Launch App</Box>
            <ArrowForwardIcon></ArrowForwardIcon>
          </Button>
          <Button
            variant='outlined'
            size='large'
            css={styles.button}
            href='https://blog.huma.finance/introducing-huma-2.0-permissionless-real-yield-on-solana'
            target='_blank'
            rel='noreferrer'
          >
            <Box css={styles.payfiButtonText}>Learn More</Box>
            <ArrowForwardIcon></ArrowForwardIcon>
          </Button>
        </Box>
      </Box>
    </HumaScrollAnimation>
  )
}
